import React, { useContext, useEffect, useRef } from 'react';
import { GlobalModalContext } from '@context/globalModalContext';
import SessionsModal from '../components/_organisms/SessionsModal';

const useSessionsDetailModal = (props) => {
    const [isModalOpen, setIsModalOpen, setModalChildren, setModalOuterClass] = useContext(GlobalModalContext);
    const prevOpenRef = useRef(false);

    useEffect(() => {
        if (isModalOpen) {
            setModalOuterClass('session-detail-modal');
        }
    }, [isModalOpen, setModalOuterClass]);

    useEffect(() => {
        if (prevOpenRef.current === true && isModalOpen === false) {
            if (props.onClose) props.onClose();
        }
        prevOpenRef.current = isModalOpen;
    }, [isModalOpen, props.onClose]);

    const openModal = () => {
        setModalChildren(() => (
            <SessionsModal {...props} />
        ));
        setIsModalOpen(true);
    };

    return { openModal, closeModal: () => setIsModalOpen(false) };
};

export default useSessionsDetailModal;